export default "/_next/static/images/081d38183b271c4c474bd7c5f285b865.png";